import { smoothScrollingAnchor } from '../utils/utils';
window.addEventListener("hashchange", updateLanguageSwitcherHash, false);

/***************************************************/
/******** Keep URL paramaters on LangSwitcher ******/
/***************************************************/
const updateLanguageSwitcherHash = () => {
    let $languageSwitcher = $(".language-switcher"),
        href = $languageSwitcher.attr("href"),
        urlParameters = [],
        regex = /[\#|\?].*$/gm;

    urlParameters = regex.exec(href);

    if (urlParameters != null) {
        href = href.substr(0, href.indexOf(urlParameters[0]));
    }

    $languageSwitcher.attr("href", href + window.location.search);
};

/***************************************/
/******** IE10 Detect *****************/
/*************************************/
const warnBrowserDetect = () => {
    var userAgent = navigator.userAgent;
    if(userAgent.indexOf("MSIE 10.0") > -1){
        document.body.classList.add("jIEten");
    }
};

const utils = () => {
    $("body").append("<span id='jScreen_search'/>");
    $("a[href='#']").on('click', function(e) {
        e.preventDefault();
    });
    updateLanguageSwitcherHash();
    warnBrowserDetect();
};

export {utils};
